// this button can get: backgroundColor, fontColor, onClick, title, width and height
// in this format:
// <Button bgColor = "pink" fontColor = "green" startFunction = {onPlay} title = "Next" width = "350px" height = "50px"> </Button>
import { useState } from "react";
import styles from "./style.module.css";

export default function Button({ moreStyle, title, marginTop, bgColor, width, height, startFunction, fontColor, disabled }) {
  const [press, setPress] = useState(false);
  const myStyle = {
    backgroundColor: bgColor,
    width: width,
    height: height,
    color: fontColor,
    ...moreStyle
  };

  const executeFunction = async () => {
    if (!press) {
      setPress(true);
      setTimeout(() => {
        startFunction && startFunction();
        setPress(false);
      }, 50)
    }

  }
  return (
    <div className={styles["wrapButton"]} style={{ marginTop: marginTop }}>
      <button disabled={disabled} className={press ? styles["submit_press"] : styles["submit"]} onClick={executeFunction} style={myStyle}>
        {title.toUpperCase()}
      </button>
    </div>
  );
}
